<template>
  <row>
    <loader :loading="loading"></loader>
    <template v-if="editorReady">
      <col4 class="avatar-preview-col">
        <avataaars
          v-if="properties.top.value"
          class="avatar-preview"
          :topType="properties.top.value"
          :accessoriesType="properties.accessoire.value"
          :facialHairType="properties.hair.value"
          :clotheType="properties.clothes.value"
          :eyeType="properties.eyes.value"
          :eyebrowType="properties.eye_brown.value"
          :mouthType="properties.mouth.value"
          :skinColor="properties.skin_color.value"
          :graphicType="properties.graphic_type.value"
          :hairColor="properties.hair_color.value"
          :facialHairColor="properties.hair_color.value"
          :topColor="properties.top_color.value"
          :clotheColor="properties.clothes_color.value"
        ></avataaars>
      </col4>
      <col8>
        <row v-if="gravatar_initialized">
          <col12>
            <property-chooser
              v-for="prop_type in property_types"
              :key="prop_type"
              :current_properties="properties_encoded"
              :type="prop_type"
              :description="typeToDescription(prop_type)"
              :value="properties[prop_type].value"
              :options="properties[prop_type].options"
              @update_prop="update_prop(prop_type, $event)"
            ></property-chooser>
          </col12>
        </row>
      </col8>
    </template>
    <col12 v-else-if="!loading">
      <p class="text-medium-emphasis">{{ $t('myprofile.avatar') }}</p>
    </col12>
  </row>
</template>

<script>

import GravatarMixin from "@/components/users/GravatarMixin";
import PropertyChooser from "@/components/users/PropertyChooser";
import Col4 from "@/components/layout/Col4";
import Col8 from "@/components/layout/Col8";
import Row from "@/components/layout/Row";
import Avataaars from "@/components/users/Avataars";
import Loader from "@/components/layout/loader";
import Col12 from "@/components/layout/Col12";
import CurrentUserMixin from "@/mixins/CurrentUserMixin";

export default {
  name: "GravatarChooser",
  mixins: [GravatarMixin, CurrentUserMixin],
  components: {Col12, Loader, PropertyChooser, Col4, Col8, Row, Avataaars},
  data () {
    return {
      edit_mode: false,
      loading: false,
    };
  },
  computed: {
    editorReady() {
      return this.gravatar_initialized && !!this.properties.top.value;
    },
  },
  watch: {
    current_user() {
      if (this.current_user) {
        this.init();
      }
    },
    gravatar_initialized() {
      this.loading = false;
    },
    properties_encoded() {
      this.update();
    },
  },
  async mounted() {
    if (!this.current_user && localStorage.token) {
      this.loading = true;
      await this.$api.get_current_user();
      this.loading = false;
    }
    this.gravatar_initialized = true;
    this.init();
  },
  methods: {
    normalizeAvatarProperties(raw) {
      if (!raw) {
        return null;
      }
      if (typeof raw === 'string') {
        try {
          return JSON.parse(raw);
        } catch {
          return null;
        }
      }
      return raw;
    },
    init() {
      const saved = this.normalizeAvatarProperties(
        this.current_user?.avatar_properties,
      );
      const property_types = Object.keys(this.properties);
      for (let i = 0; i < property_types.length; i++) {
        const property_type = property_types[i];
        const set_value = saved ? saved[property_type] : false;
        if (set_value) {
          this.update_prop(property_type, set_value);
        } else {
          this.update_prop(property_type, this.get_random_value(property_type));
        }
      }
      this.update();
    },
    toggle_edit() {
      this.edit_mode = !this.edit_mode;
    },
    update() {
      this.$emit('update', this.properties_encoded);
    },
  },
};
</script>

<style scoped>
.avatar-preview-col {
  max-width: 400px;
}
.avatar-preview {
  max-width: 350px;
  width: 100%;
}
</style>
